import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'settings' }).lazy(() =>
  import('./site-settings.lazy.tsx').then((module) => module.Route),
);
